import { render, staticRenderFns } from "./FmRateDemo.vue?vue&type=template&id=464af658&scoped=true&"
import script from "./FmRateDemo.vue?vue&type=script&lang=js&"
export * from "./FmRateDemo.vue?vue&type=script&lang=js&"
import style0 from "./FmRateDemo.vue?vue&type=style&index=0&id=464af658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464af658",
  null
  
)

export default component.exports